import React, { useState } from 'react';

// Auto-fix picker: shows each proposed fix as a checkbox row so the author
// applies only the fixes they want. Replaces the old all-or-nothing
// window.confirm flow.

const AutoFixModal = ({ items, onApply, onClose }) => {
  const [selected, setSelected] = useState(() => new Set(items.map(i => i.key)));

  const toggle = (key) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  };

  const count = selected.size;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 2000,
        background: 'rgba(0,0,0,0.35)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        style={{
          background: 'var(--color-bg-panel, #fff)',
          borderRadius: 8,
          boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
          width: 480,
          maxWidth: '92vw',
          padding: '18px 20px',
          fontFamily: 'var(--font-family-primary, inherit)',
        }}
      >
        <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 600, color: 'var(--color-text-primary, #202124)' }}>
          Auto-fix
        </h3>
        <p style={{ margin: '0 0 12px', fontSize: 13, color: 'var(--color-text-secondary, #5F6368)' }}>
          Pick the fixes to apply. Everything is undoable.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: '50vh', overflowY: 'auto' }}>
          {items.map(item => (
            <label
              key={item.key}
              title={item.detail || ''}
              style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 14, cursor: 'pointer', color: 'var(--color-text-primary, #202124)' }}
            >
              <input
                type="checkbox"
                checked={selected.has(item.key)}
                onChange={() => toggle(item.key)}
                style={{ marginTop: 2 }}
              />
              <span>
                {item.label}
                <span style={{ color: 'var(--color-text-tertiary, #888)', fontSize: 12 }}> ({item.key})</span>
              </span>
            </label>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
          <button
            onClick={onClose}
            style={{ padding: '6px 14px', borderRadius: 4, border: '1px solid var(--color-border-medium, #DADCE0)', background: '#fff', cursor: 'pointer' }}
          >
            Cancel
          </button>
          <button
            disabled={count === 0}
            onClick={() => onApply(Array.from(selected))}
            style={{
              padding: '6px 14px', borderRadius: 4, border: '1px solid var(--color-primary-600, #3D85E6)',
              background: count === 0 ? 'var(--color-neutral-200, #E8EAED)' : 'var(--color-primary-500, #5B9FFF)',
              color: count === 0 ? 'var(--color-text-disabled, #BDC1C6)' : '#fff',
              cursor: count === 0 ? 'default' : 'pointer',
            }}
          >
            {count === 1 ? 'Apply 1 fix' : `Apply ${count} fixes`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutoFixModal;
